import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const TextInput = ({ label, type = 'text', value, placeholder, onChange, disabled = false }) => {
  return (
    <div className="text-input-wrapper">
      <label>{label}</label>

      <input
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};

TextInput.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

export default TextInput;
